/* ==========================================================================
   SearcherFerryHotel > Client > trailer
   ========================================================================== */
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const ToggleTemplate = require('@bluekiri/alexandria-contrib-components/components/toggle-rxjs/template');
const ToggleClient = require('@bluekiri/alexandria-contrib-components/components/toggle-rxjs/client/js');
const ToggleActions = require('@bluekiri/alexandria-contrib-components/components/toggle-rxjs/client/js/store/actions');

const { addDimesions, destroyDimensions } = require('../dimesions');

const configuration = require('../../../config');

function createTrailer(instance) {
    const { config = {}, store = {} } = instance;
    const { context = {}, literals = {} } = config;
    const { trailerLabel = '' } = literals;

    const { trailer } = store.select('data');

    /* Prepare data toggle trailer */
    const dataToggle = addData(
        {
            label: trailerLabel,
            checked: trailer
        },
        { type: configuration().type.trailer }
    );

    return ToggleTemplate(dataToggle, context);
}

function addTrailer(instance) {
    const result = instance;
    const { reactions = {}, vehicleInput = {} } = instance;
    const { panel } = vehicleInput;

    if (!panel) return;

    /* Data Panel */
    const { panelType } = vehicleInput.store.select('data');
    const panelSelector = `[data-type="${panelType}"]`;

    /* Node */
    const node = toNode(createTrailer(instance))[0];

    /* Append component to dom */
    const vehicleDimensionsNode = panel.element.querySelector(`[${configuration().hooks.vehicleDimensions}]`);

    if (vehicleDimensionsNode) vehicleDimensionsNode.appendChild(node);

    /* Init toggle */
    result.trailer = ToggleClient(
        `${panelSelector} [data-component="ToggleRxjs"][data-type="${configuration().type.trailer}"]`
    );

    if (result.trailer) {
        /* Extend reactions */
        result.reactions = {
            ...reactions,
            toggleTrailer: result.trailer.store.subscribe((state, action) => {
                if (action.type !== ToggleActions.types.TOGGLE) return;

                const { checked: toggleChecked } = result.trailer.store.select('toggle');

                /* Toggle on */
                /* Add input dimensions */
                if (toggleChecked) {
                    addDimesions(instance, 'trailer');

                    const trailerLength = instance.trailerDimensions[0].store.select('input').value || undefined;
                    const trailerHeight = instance.trailerDimensions[1].store.select('input').value || undefined;

                    /* Sync store */
                    instance.actions.changeVehicle({ trailer: true, trailerLength, trailerHeight });
                    return;
                }

                /* Toggle off */
                /* Destroy inputs */
                destroyDimensions(instance, 'trailer');

                /* Sync store */
                instance.actions.changeVehicle({
                    trailer: false,
                    trailerLength: undefined,
                    trailerHeight: undefined
                });
            })
        };

        /* Sync store, data toggle, set data trailer */
        const { checked } = result.trailer.store.select('toggle');
        instance.actions.setData({ trailer: checked });

        /* add dimensions inputs, instance.trailerDimensions */
        if (checked) addDimesions(instance, 'trailer');
    }
}

function destroyTrailer(instance) {
    if (!instance.trailer) return;

    const result = instance;

    /* Destroy */
    instance.trailer.actions.destroy();

    /* Unsubscribe */
    result.reactions.toggleTrailer.unsubscribe();

    /* Remove references */
    delete result.reactions.toggleTrailer;
    delete result.trailer;
}

module.exports = {
    addTrailer,
    destroyTrailer
};
